// extracted by mini-css-extract-plugin
export default {"container":"Support_container__mrs+4","title":"Support_title__Mmkzf","subtitle":"Support_subtitle__SqBbf","link":"Support_link__cupJj"};